module.exports = __webpack_public_path__ + "img/hr-bigass-explosion-36f-2.a9d77a0f.png";